<template>
  <div>
    <div class="step-header">
      <h2 class="step-title">Escolha os tipos de materiais que deseja estudar</h2>
    </div>

    <div v-if="!loading && studyMaterials.length > 0" class="mt-10">
      <b-row>
        <b-col lg="6" class="py-0">
          <div>
            <v-checkbox v-for="material in studyMaterials.slice(0, Math.ceil(studyMaterials.length / 2))"
                        color="#7C56F6" dense :key="material.id" :value="material.id" class="material-check"
                        v-model="materialsChosen">
              <template v-slot:label>
                <div class="d-flex align-content-center">
                  <v-icon>{{ material.icon }}</v-icon>
                  <span class="ml-3">{{ material.name }}</span>
                </div>
              </template>
            </v-checkbox>
          </div>
        </b-col>

        <b-col lg="6" class="py-0 d-lg-flex justify-content-lg-end">
          <div>
            <v-checkbox v-for="material in studyMaterials.slice(Math.ceil(studyMaterials.length / 2))" color="#7C56F6"
                        dense :key="material.id" :value="material.id" class="material-check" v-model="materialsChosen">
              <template v-slot:label>
                <div class="d-flex align-content-center">
                  <v-icon>{{ material.icon }}</v-icon>
                  <span class="ml-3">{{ material.name }}</span>
                </div>
              </template>
            </v-checkbox>
          </div>
        </b-col>
      </b-row>
    </div>

    <div v-if="showMessage" class="schedule-length-message">
      <v-icon color="#F7B329" class="mr-2">mdi-alert-circle-outline</v-icon>
      <span>{{ totalTimeText }}</span>
    </div>

    <div class="text-center" v-if="loading">
      <img src="https://jaleko-files.s3.sa-east-1.amazonaws.com/img/gif.gif" alt="Carregando">
    </div>

    <div class="step-buttons d-flex justify-content-between">
      <v-btn rounded outlined class="btn previous-step-button dark-button" large @click="previousStep">
        <v-icon class="mr-3">mdi-arrow-left</v-icon>
        Voltar
      </v-btn>

      <v-btn rounded class="btn next-step-button primary-button" large v-if="contentTime > 0" color="#F47D3A"
             @click="nextStep">
        Próxima
        <v-icon class="ml-3">mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>

import './style.scss'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'StepThree',

  async mounted() {
    this.startLoading()
    await this.loadStudyMaterials()
    await this.getContentTime()
    this.stopLoading()
  },

  computed: {
    ...mapGetters(['contentTime', 'loading', 'studyMaterials', 'scheduleMaterials']),

    materialsChosen: {
      get() {
        return this.scheduleMaterials
      },

      set(value) {
        this.setScheduleMaterials(value)
      }
    },

    totalTimeText() {
      return 'Você irá precisar de ' + Math.floor(this.contentTime / 3600)
          + ' horas  e ' + Math.floor(this.contentTime % 3600 / 60)
          + ' minutos para estudar os materiais escolhidos.'
    },

    showMessage() {
      return !this.loading && this.studyMaterials.length > 0 && this.materialsChosen.length > 0
    }
  },

  methods: {
    ...mapActions([
      'getContentTime',
      'loadStudyMaterials',
      'setCreationStep',
      'setScheduleMaterials',
      'startLoading',
      'stopLoading'
    ]),

    nextStep() {
      this.setCreationStep(4)
    },

    previousStep() {
      this.setCreationStep(2)
    },
  }
}
</script>
